import {
  ServiceFeeModel,
  CalculateArea,
  GameType,
} from '../../model/api-modules/price-calculator';
import getFormatMessage from '../../locales/get-format-message';

export const SERVICES_LIST = [
  {
    category: getFormatMessage('price_multiplayer'),
    options: [
      {
        label: getFormatMessage('price_player'),
        value: ServiceFeeModel.Player,
      },
      {
        label: getFormatMessage('price_party'),
        value: ServiceFeeModel.Party,
      },
      {
        label: getFormatMessage('price_lobby'),
        value: ServiceFeeModel.Lobby,
      },
      {
        label: getFormatMessage('price_matchmaking'),
        value: ServiceFeeModel.MatchMaking,
      },
      {
        label: getFormatMessage('price_microservice'),
        value: ServiceFeeModel.Microservice,
      },
      {
        label: getFormatMessage('price_goals'),
        value: ServiceFeeModel.Goals,
      },
      {
        label: getFormatMessage('price_ds_hosting'),
        value: ServiceFeeModel.DSHosting,
      },
    ],
  },
  {
    category: getFormatMessage('price_social'),
    options: [
      {
        label: getFormatMessage('price_friends'),
        value: ServiceFeeModel.Friends,
      },
      {
        label: getFormatMessage('price_text_chat'),
        value: ServiceFeeModel.TextChat,
      },
      {
        label: getFormatMessage('price_voice_chat'),
        value: ServiceFeeModel.VoiceChat,
      },
      {
        label: getFormatMessage('price_guild'),
        value: ServiceFeeModel.Guild,
      },
      {
        label: getFormatMessage('price_leaderboards'),
        value: ServiceFeeModel.LeaderBoards,
      },
    ],
  },
  {
    category: getFormatMessage('price_economy'),
    options: [
      {
        label: getFormatMessage('price_game_items'),
        value: ServiceFeeModel.GameItems,
      },
      {
        label: getFormatMessage('price_store'),
        value: ServiceFeeModel.Store,
      },
    ],
  },
  {
    category: getFormatMessage('price_engage'),
    options: [
      {
        label: getFormatMessage('price_mails'),
        value: ServiceFeeModel.Mails,
      },
      {
        label: getFormatMessage('price_private_access'),
        value: ServiceFeeModel.PrivateAccess,
      },
      {
        label: getFormatMessage('price_command'),
        value: ServiceFeeModel.Command,
      },
    ],
  },
  {
    category: getFormatMessage('price_analytics'),
    options: [
      {
        label: getFormatMessage('price_dashboard'),
        value: ServiceFeeModel.Dashboard,
      },
      {
        label: getFormatMessage('price_telemetry'),
        value: ServiceFeeModel.Telemetry,
      },
      {
        label: getFormatMessage('price_health_monitor'),
        value: ServiceFeeModel.HealthMonitor,
      },
      {
        label: getFormatMessage('price_session_track'),
        value: ServiceFeeModel.SessionTrack,
      },
    ],
  },
  {
    category: getFormatMessage('price_content'),
    options: [
      {
        label: getFormatMessage('price_remote_config'),
        value: ServiceFeeModel.RemoteConfig,
      },
      {
        label: getFormatMessage('price_content_delivery'),
        value: ServiceFeeModel.ContentDelivery,
      },
    ],
  },
];

export const REGION_OPTIONS = [
  {
    label: getFormatMessage('price_area_cn'),
    value: CalculateArea.CN,
  },
  {
    label: getFormatMessage('price_area_intl'),
    value: CalculateArea.INTL,
  },
];

export const TYPE_OPTIONS = [
  {
    label: getFormatMessage('price_moba'),
    value: GameType.MOBA,
  },
  {
    label: getFormatMessage('price_shooter_games'),
    value: GameType.Shooter,
  },
  {
    label: getFormatMessage('price_rpg'),
    value: GameType.RPG,
  },
  {
    label: getFormatMessage('price_strategy_games'),
    value: GameType.Strategy,
  },
  {
    label: getFormatMessage('price_card_games'),
    value: GameType.Card,
  },
  {
    label: getFormatMessage('price_simulation_games'),
    value: GameType.Simulation,
  },
  {
    label: getFormatMessage('price_adventure_games'),
    value: GameType.Adventure,
  },
  {
    label: getFormatMessage('price_action_games'),
    value: GameType.Action,
  },
  {
    label: getFormatMessage('price_racing_games'),
    value: GameType.Racing,
  },
  {
    label: getFormatMessage('price_party_games'),
    value: GameType.Party,
  },
  {
    label: getFormatMessage('price_sports_games'),
    value: GameType.Sports,
  },
  {
    label: getFormatMessage('price_casual_games'),
    value: GameType.Casual,
  },
  {
    label: getFormatMessage('price_survival_games'),
    value: GameType.Survival,
  },
  {
    label: getFormatMessage('price_open_world_games'),
    value: GameType.OpenWorld,
  },
  {
    label: getFormatMessage('price_fighting_games'),
    value: GameType.Fighting,
  },
  {
    label: getFormatMessage('price_others'),
    value: GameType.Others,
  },
];
